import cn from 'classnames';
import { Heading, P, Section, Wrapper } from 'components/base';
import isEmpty from 'lodash-es/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import V01 from 'svgs/events/sme/v01.svg';
import V02 from 'svgs/events/sme/v02.svg';
import V03 from 'svgs/events/sme/v03.svg';
import { centerList, dark, v01, v02, v03, videoLi, videoLists, videoSection, videoWrapper } from './Videos.module.scss';

const Videos = ({ data: { heading, description, links }, theme }) => {
  const HeadingMargin = isEmpty(description) ? 'L' : 'S';
  const themeDark = theme === 'dark';
  const justOneVideo = (links.length === 1);
  return (
    <Section className={cn(videoSection, { [dark]: themeDark })} padding="L">
      { heading &&  
       <Wrapper size="MS">
        <Heading Tag="h2" center marginBottom={HeadingMargin} bold size="M">
          {heading}
        </Heading>
        {description && <P Tag="h3" marginBottom="S" center size="L">{description}</P>}
      </Wrapper>
      }
      <Wrapper size="L">
        <ul className={cn(videoLists, {[centerList]: justOneVideo})}>
          {links.map((item, i) => 
            <li key={i} className={videoLi}>
              <div className={videoWrapper}>
                <iframe width="560" height="315" src={item} title="Newsleopard" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </div>
            </li>
          )}
        </ul>
      </Wrapper>
      {themeDark && <><V01 className={v01} /><V02 className={v02} /><V03 className={v03} /></>}
    </Section>
  );
};

Videos.propTypes = {
  data: PropTypes.shape({
    links: PropTypes.array.isRequired,
    heading: PropTypes.string,
    description: PropTypes.string,
  }),
  theme: PropTypes.oneOf(['dark', 'white']),
};
Videos.defaultProps = {
  data: [],
  theme: 'dark'
}

export default Videos;